module.exports = __webpack_public_path__ + "media/images/pic/saska/saska_headmaster-eefb46a1e778b03735647cb1ff37e7ea.svg";